export default __webpack_public_path__ + "static/media/crypto-fiat.892080d7.svg";